import(/* webpackMode: "eager" */ "/vercel/path0/src/app/rotate-pdf/page.tsx");
